import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router, Params } from '@angular/router';
import * as _ from 'lodash';
import { InspectionModelService, InspectionService, ApplicationService, MachineModuleService } from '../../shared/services/index';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ApplicationType } from '../../utils';
import { ApplicationSubType } from '../components';
import { switchMap } from 'rxjs/operators';
import { SnackBarService } from '../../shared/services/snack-bar.service';

@Component({
  templateUrl: './newFromModel.component.html',
  standalone: false
})
export class NewInspectionModelPageComponent extends BaseModalPageComponent implements OnInit {
  models: any;
  selectedModel: any;
  orderByFieldName = 'name';
  direction = 'asc';
  query = '';
  createProcessing = false;
  productLineId: string;
  categoryId: string;
  machineId: string;
  isOptimization: boolean;
  applicationSubType: number;
  inspectionId: string;
  inspectionName: string;
  serialNumber: string;

  constructor(
    private inspectionModelService: InspectionModelService,
    private inspectionService: InspectionService,
    location: Location,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private applicationService: ApplicationService,
    private snackBar: SnackBarService,
    private machineModuleService: MachineModuleService
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.applicationService.isOptimization().subscribe((data) => {
        this.isOptimization = data;

        this.applicationSubType = +params['applicationSubType'];

        if (!this.applicationSubType && this.currentAppType === ApplicationType.Installation) {
          this.applicationSubType = ApplicationSubType.ParentInstallation;
        }
        this.inspectionId = params['inspectionId'];

        const productLineId = params['productLineId'];
        if (productLineId != null) this.productLineId = productLineId;

        const categoryId = params['categoryId'];
        if (categoryId != null) this.categoryId = categoryId;

        this.machineId = params['machineId'];
        this.serialNumber = params['serialNumber'];

        this.inspectionName = params['inspectionName'];
        this.query = '';
        this.initData();
        this.cdRef.detectChanges();
      });
    });
  }

  selectModel(model: any) {
    this.selectedModel = model;

    for (let i = 0; i < this.models.length; i++) {
      this.models[i].selected = false;
    }
    this.selectedModel.selected = true;
    this.cdRef.detectChanges();
  }

  save() {
    this.createProcessing = true;
    this.inspectionModelService
      .getModel(this.selectedModel.id)
      .pipe(
        switchMap((model) =>
          this.inspectionService.newInspectionFromModelJob({
            machineId: this.machineId,
            serialNumber: this.serialNumber,
            modelId: model.id,
            name: this.inspectionName,
            attachedTemplates: model.attachedTemplates,
            parentId: this.inspectionId,
            productLineId: this.productLineId
          })
        )
      )
      .subscribe((el: any) => {
        this.snackBar.info('inspections.create-info', 8);
        this.machineModuleService.getMachine(this.serialNumber).subscribe(
          () => this.router.navigate([this.appRoute, 'machines', this.serialNumber, 'inspections']),
          () =>
            this.inspectionId
              ? this.router.navigate([this.inspectionsRoute, this.inspectionId, 'inspections'])
              : this.router.navigate([this.inspectionsRoute])
        );
      });
  }

  cancel() {
    this.goToBack();
  }

  initData() {
    const self = this;
    this.inspectionModelService.getPublishedModels().subscribe((data) => {
      this.models = data.filter((m) => (this.applicationSubType ? m.applicationSubType === this.applicationSubType : true));
      if (this.isOptimization) {
        this.models = _.filter(this.models, function (m: any) {
          return m.categories && _.find(m.categories, (c: any) => c.ProductLineId === self.productLineId) !== undefined;
        });
      } else {
        this.models = _.filter(this.models, function (m: any) {
          return (
            m.categories &&
            _.find(m.categories, (c: any) => c.CategoryId === self.categoryId && c.ProductLineId === self.productLineId) !== undefined
          );
        });
      }
    });
  }

  ngOnInit(): void {
    this.initRoute();
  }

  processData() {
    _.forEach(this.models, (el) => {
      el.search = (query: string): boolean => el.name == null || el.name.toLowerCase().indexOf(query) !== -1;
    });
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
